module.exports = __webpack_public_path__ + "media/loader.e88f13c9.mp4";